import React from 'react';
import Conversation from 'components/Elements/Conversation';
import ElementBase from '../base';

const ConversationElement = props => {
  const { content, handleUpdate, applyChanges, isDragging, isLinked } = props;

  const onChange = (changes, options) => {
    applyChanges(changes, options);
    handleUpdate(changes);
  };

  return (
    <Conversation
      disabled={isLinked}
      content={content}
      onChange={onChange}
      isDragging={isDragging}
      {...props}
    />
  );
};

export default ElementBase(ConversationElement);
